import { Components, Theme } from '@mui/material'

export const MuiCheckbox = (): Components<Theme>['MuiCheckbox'] => {
  return {
    defaultProps: {
      color: 'primary',
    },
  }
}
